import { CalendarDays, ChevronDown } from 'lucide-react'
import { DateTime } from 'luxon'
import { DateRangePicker, type DatePreset } from '~/components/ui/date-range-picker'
import { frenchDateOfIso } from '~/lib/iso-date'
import type { LogisticsSearch } from '~/routes/_authenticated/logistics/-search-schema'
import { parseLocalDate, toIsoDate } from '~/utils/dates/local-date'
import { LOGISTICS_FILTER_CHIP } from './logistics-styles'

const presets: DatePreset<'all'>[] = [
  {
    value: 'all',
    label: 'Toutes les dates',
    // Le DS utilise from: null pour son choix sans borne ; ici ce choix efface les deux bornes.
    getRange: () => ({ from: null, to: DateTime.now().toJSDate() }),
  },
]

/** Champ « Période » du menu « Filtres » de la carte (maquette « MAP V4 ») : pleine largeur, blanc. */
const MAP_PANEL_FIELD =
  'h-auto w-full justify-start gap-2 rounded-[10px] border border-black/6 bg-white px-[15px] py-3 text-sm font-medium text-primary-600 hover:bg-white'

/**
 * Une période choisie puis appliquée, ou aucune ; même barre sur la liste et le détail. La carte du
 * simulateur en reprend une copie dans son menu « Filtres » (`field`), liée aux mêmes paramètres
 * d'URL : les deux restent d'accord.
 */
export function LogisticsPeriodFilter({
  search,
  onSearchChange,
  variant = 'chip',
}: {
  search: LogisticsSearch
  onSearchChange: (patch: Partial<LogisticsSearch>) => void
  variant?: 'chip' | 'field'
}) {
  const from = search.from ? parseLocalDate(search.from) : null
  const to = search.to ? parseLocalDate(search.to) : DateTime.now().toJSDate()
  const label =
    search.from && search.to
      ? `${frenchDateOfIso(search.from)} - ${frenchDateOfIso(search.to)}`
      : 'Période'

  return (
    <DateRangePicker
      value={{ from, to }}
      activePreset={from === null ? 'all' : null}
      presets={presets}
      className={variant === 'chip' ? LOGISTICS_FILTER_CHIP : MAP_PANEL_FIELD}
      triggerContent={() =>
        variant === 'chip' ? (
          <>
            <span>{label}</span>
            <ChevronDown className="size-4 shrink-0" />
          </>
        ) : (
          <>
            <span className="flex-1 text-left">{label}</span>
            <CalendarDays className="size-4 shrink-0" />
          </>
        )
      }
      onChange={(range) =>
        onSearchChange({
          from: range.from ? toIsoDate(range.from) : undefined,
          to: range.from ? toIsoDate(range.to) : undefined,
        })
      }
    />
  )
}
